import * as z from "zod";

export const getTeamAutomations = {
  name: "getTeamAutomations" as const,
  description:
    "The team's automations by id and name, to name one in a condition or to find one to inspect.",
  mutates: false,
  input: z.void(),
  output: z.array(z.object({ id: z.string(), name: z.string() })),
};
